/*
Interface to store key value pairs for different environments
*/

class EnvStorageInterface {
    /*
        @param  (string) env  the name of the environment get the value from
        @param  (string) key

        @return undefined or value
    */
    get = (env, key) => {
        throw new Error("get method not implemented");
    }

    /*
        @param  (string) env  the name of the environment store the the key value in
        @param  (string) key
        @param  (any)    value

        @return this
    */
    set = (env, key, value) => {
        throw new Error("set method not implemented");
    }
}

export default EnvStorageInterface;